<template>
  <form
    class="flex w-full flex-col space-y-6"
    @submit="onSubmit"
  >
    <FormInputPassword
      v-if="requireCurrentPassword"
      autocomplete="current-password"
      label="Current Password"
      name="currentPassword"
    />
    <FormInputPassword
      autocomplete="new-password"
      label="New Password"
      name="password"
    />
    <FormInputPassword
      autocomplete="new-password"
      label="Confirm Password"
      name="confirmPassword"
    />

    <div
      :class="[
        'flex items-center',
        requireCurrentPassword
          ? 'justify-between'
          : 'justify-end',
      ]"
    >
      <RouterLink
        v-if="requireCurrentPassword"
        :to="{
          name: 'resetPasswordRequest',
          params: { userType: userType },
        }"
        class="text-sm text-primary hover:text-primary/70"
      >
        Forgot password?
      </RouterLink>
      <FormSubmitButton>
        {{
          requireCurrentPassword
            ? "Update Password"
            : "Set Password"
        }}
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { type SubmissionContext } from "vee-validate"

const props = defineProps<{
  requireCurrentPassword: boolean
  userType: "merchant-user" | "merchant-group-admin"
}>()

const emit = defineEmits<{
  (
    event: "submit",
    params: SetChangeResetPasswordFormOutput,
    context: SubmissionContext<SetChangeResetPasswordFormInput>
  ): void
}>()

const { handleSubmit } = useSetChangeResetPasswordForm()

const onSubmit = handleSubmit(async (values, context) => {
  emit("submit", values, context)
})
</script>
